// src/utils/cacheUtils.js

/**
 * Utilitaires pour la gestion du cache localStorage
 */

const CACHE_PREFIX = "esupplyvet_";
const DEFAULT_TTL = 30 * 60 * 1000; // 30 minutes en millisecondes

/**
 * Sauvegarde des données dans le localStorage avec TTL
 * @param {string} key - Clé de cache
 * @param {any} data - Données à sauvegarder
 * @param {number} ttl - Durée de vie en millisecondes
 */
export function saveToCache(key, data, ttl = DEFAULT_TTL) {
  try {
    const cacheData = {
      data,
      timestamp: Date.now(),
      ttl,
      version: "1.0",
    };

    localStorage.setItem(CACHE_PREFIX + key, JSON.stringify(cacheData));
    return true;
  } catch (error) {
    console.warn("Erreur lors de la sauvegarde en cache:", error);
    return false;
  }
}

/**
 * Récupère des données du localStorage
 * @param {string} key - Clé de cache
 * @returns {any|null} - Données ou null si invalide/inexistant
 */
export function getFromCache(key) {
  try {
    const cached = localStorage.getItem(CACHE_PREFIX + key);
    if (!cached) return null;

    const cacheData = JSON.parse(cached);
    const now = Date.now();

    // Vérifier si le cache est encore valide
    if (now - cacheData.timestamp > cacheData.ttl) {
      localStorage.removeItem(CACHE_PREFIX + key);
      return null;
    }

    return cacheData.data;
  } catch (error) {
    console.warn("Erreur lors de la lecture du cache:", error);
    return null;
  }
}

/**
 * Vérifie si le cache est valide
 * @param {string} key - Clé de cache
 * @returns {boolean}
 */
export function isCacheValid(key) {
  try {
    const cached = localStorage.getItem(CACHE_PREFIX + key);
    if (!cached) return false;

    const cacheData = JSON.parse(cached);
    const now = Date.now();

    return now - cacheData.timestamp <= cacheData.ttl;
  } catch (error) {
    return false;
  }
}

/**
 * Supprime une entrée du cache
 * @param {string} key - Clé de cache
 */
export function removeFromCache(key) {
  try {
    localStorage.removeItem(CACHE_PREFIX + key);
  } catch (error) {
    console.warn("Erreur lors de la suppression du cache:", error);
  }
}

/**
 * Nettoie tous les caches expirés
 */
export function cleanExpiredCache() {
  try {
    const keys = Object.keys(localStorage);
    const now = Date.now();

    keys.forEach(key => {
      if (key.startsWith(CACHE_PREFIX)) {
        try {
          const cacheData = JSON.parse(localStorage.getItem(key));
          if (now - cacheData.timestamp > cacheData.ttl) {
            localStorage.removeItem(key);
          }
        } catch (error) {
          // Supprimer les entrées corrompues
          localStorage.removeItem(key);
        }
      }
    });
  } catch (error) {
    console.warn("Erreur lors du nettoyage du cache:", error);
  }
}
